export const SELECTING_ACTION_DRAG_SIZE_TRIGGER_IN_PX = 4 as const
export const SELECTING_ACTION_HOLD_DURATION_TRIGGER_IN_MS = 200 as const
export const TILE_SIDE_IN_PX = 48 as const
export const ZOOM_LEVELS = [0.5, 0.75, 1, 2, 3, 4] as const

export enum TileKey {
  HousingLow = 'HousingLow',
  Meadow = 'Meadow',
  RoadIntersection = 'RoadIntersection',
  RoadNorthEast = 'RoadNorthEast',
  RoadNorthEastSouth = 'RoadNorthEastSouth',
  RoadNorthSouth = 'RoadNorthSouth',
}

/** @default "Idle" */
export enum UserActionState {
  Idle = 'Idle',
  /** The user is panning the scene. */
  Panning = 'Panning',
  /** The user pointer is down but we don't know yet if it's a click or a drag. */
  PendingSelection = 'PendingSelection',
  /** The user is selecting tiles. */
  Selecting = 'Selecting',
}
